import { render, staticRenderFns } from "./EditSchool/template.html?vue&type=template&id=271a216a&scoped=true&"
import script from "./EditSchool/script.ts?vue&type=script&lang=js&"
export * from "./EditSchool/script.ts?vue&type=script&lang=js&"
import style0 from "./EditSchool/style.scss?vue&type=style&index=0&id=271a216a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271a216a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
